import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { State } from './types';

export const fetchSituationsCategory = createAction('situationsCategory/fetch', () => ({
  payload: undefined,
}));

export const fetchedSituationsCategory = createAction(
  'situationsCategory/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchSituationsCategory,
  fetchedSituationsCategory,
};
